import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const updateSchemaCommentStmtInstruction = `
#### Update comment in schema entity
- Syntax: \`update comment <order> in <entity_name> to "<comment>";\`
- Example: \`update comment 1 in Author to "This is an author entity";\`

Important notes:
- The comment is a string that describes the entity.
- The comment is used for documentation purposes.
- The comment is not used by the database engine.
`;
export const stmtUpdateSchemaComment = ({ order, comment, entityName }) => {
    return `update comment ${order} in ${entityName} to "${comment}";`;
};
export const stmtForHumanUpdateSchemaComment = ({ order, comment, entityName }) => {
    return `Update the comment with order ${order} in the database table __${entityName}__ to "${comment}".`;
};
export const updateSchemaCommentHandler = createSchemaStatementHandler({
    type: 'update comment',
    parse: line => {
        const match = /^update comment (?<order>[\d]+) in (?<entityName>\w+) to "(?<comment>.+)"/.exec(line);
        return match?.groups
            ? {
                type: 'update comment',
                order: Number.parseInt(match.groups.order),
                comment: match.groups.comment,
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanUpdateSchemaComment,
    apply: (stmt, builder) => {
        builder.updateSchemaExtensions(it => {
            const comments = it.comments[stmt.entityName];
            if (!comments) {
                throw new Error(`No comments found for entity ${stmt.entityName}`);
            }
            if (stmt.order < 0 || stmt.order >= comments.length) {
                throw new Error(`Comment index out of bounds for entity ${stmt.entityName}`);
            }
            comments[stmt.order] = {
                comment: stmt.comment,
            };
        });
    },
});
//# sourceMappingURL=UpdateSchemaCommentStmt.js.map